import { LoadingIndicator } from 'components/common/LoadingIndicator';
import { Pmp, PmpStatus } from 'core/pmp/Pmp';
import { DefaultPmpManager } from 'core/pmp/PmpManager';
import { useCallAPI } from 'hooks/useCallAPI';
import { createContext, PropsWithChildren, useEffect, useState } from 'react';

const pmpManager = new DefaultPmpManager();

const PmpListContext = createContext<Pmp[] | null>(null);

export const PmpListProvider: React.FC<
  PropsWithChildren<{ l1ObjectId: number }>
> = ({ l1ObjectId, children }) => {
  const [pmpList, setPmpList] = useState<Pmp[]>();

  const { callAPIs } = useCallAPI();

  useEffect(() => {
    callAPIs(
      [() => pmpManager.getPmpsByL1ObjectId(l1ObjectId, [PmpStatus.ACTIVE])],
      (pmps: Pmp[]) => {
        setPmpList(pmps);
      }
    );
  }, [l1ObjectId, callAPIs]);

  if (!pmpList) {
    return <LoadingIndicator />;
  }

  return (
    <PmpListContext.Provider value={pmpList}>
      {children}
    </PmpListContext.Provider>
  );
};
